import { applyMiddleware, compose, createStore } from "redux";
import { DefaultRootState } from "react-redux";
import { reducer } from "./redux.store";
import isBrowserContext from "helpers/isBrowserContext";
import isDevelopment from "helpers/isDevelopment";
import { thunk } from "redux-thunk";

const configureStore = (initialState?: DefaultRootState): any => {
    const middleware = [
        thunk
    ];

    const composeEnhancers = isBrowserContext() && isDevelopment() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    const enhancer = composeEnhancers(
        applyMiddleware(...middleware)
    );

    const store = createStore(
        reducer(),
        enhancer
    );

    return store;
};

export default configureStore;